export { PayflipLogo } from './payflip-logo';
